import { chartCumulativeSeriesName } from "./chartDefaultConfigs";
import {
  HighchartsChartDataSeriesOption,
  HighchartsChartDataType,
} from "../types/common";

export const getChartCumulativeSeries = (
  chartData: HighchartsChartDataType,
): HighchartsChartDataSeriesOption => {
  const totals = chartData.categories.map((_, index) => {
    return chartData.series.reduce((acc, s) => {
      if (s.purpose === "visualization") {
        return acc;
      }

      return acc + (s.data[index]?.y ?? 0);
    }, 0);
  });

  const cumulativeTotals: { y: number }[] = [];

  let sum = 0;
  totals.forEach((val, index) => {
    sum = sum + val;
    cumulativeTotals[index] = { y: sum };
  }, 0);

  return {
    name: chartCumulativeSeriesName,
    type: "line",
    color: "#42A5F5",
    data: cumulativeTotals,
    marker: { enabled: true, radius: 4 },
    lineWidth: 2,
  };
};
